import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "brandNamesTextarea", "dryRunCheckbox", "result"]

  submit() {
    const brandNamesText = this.brandNamesTextareaTarget.value
    const dryRun = this.dryRunCheckboxTarget.checked

    if (!String(brandNamesText || "").trim()) {
      this.resultTarget.innerHTML = '<div class="alert alert-danger mb-0">Please enter at least one brand name.</div>'
      return
    }

    this.buttonTarget.disabled = true
    this.resultTarget.innerHTML = '<div class="alert alert-info mb-0">' +
      (dryRun ? "Previewing HubSpot changes..." : "Updating HubSpot properties...") +
      "</div>"

    $.post("/components/it_tools/hubspot_brand_onboarding_tool/update_brand_options", {
      brand_names_text: brandNamesText,
      dry_run: dryRun
    }).done((data) => {
      if (!data.success && data.errors) {
        this.resultTarget.innerHTML = '<div class="alert alert-danger mb-0">' + this.escapeHtml(data.errors) + "</div>"
        return
      }

      this.resultTarget.innerHTML = this.renderResult(data)
    }).fail((jqXHR) => {
      const message = jqXHR.responseJSON && jqXHR.responseJSON.errors
        ? jqXHR.responseJSON.errors
        : "Something went wrong while updating HubSpot."
      this.resultTarget.innerHTML = '<div class="alert alert-danger mb-0">' + this.escapeHtml(message) + "</div>"
    }).always(() => {
      this.buttonTarget.disabled = false
    })
  }

  renderResult(data) {
    const alertClass = data.success ? "alert-success" : "alert-warning"
    let html = '<div class="alert ' + alertClass + ' mb-3">' + this.escapeHtml(data.message) + "</div>"

    if (!data.brand_results || !data.brand_results.length) {
      return html
    }

    html += '<div class="table-responsive">'
    html += '<table class="table table-sm table-striped hubspot-brand-onboarding-result-table">'
    html += "<thead><tr><th>Brand</th><th>Status</th><th>Details</th></tr></thead><tbody>"

    data.brand_results.forEach((brandResult) => {
      html += "<tr>"
      html += "<td>" + this.escapeHtml(brandResult.brand_name) + "</td>"
      html += '<td><span class="badge text-bg-' + this.badgeClassForStatus(brandResult.status) + '">'
      html += this.escapeHtml(this.titleizeStatus(brandResult.status)) + "</span></td>"
      html += "<td>"
      html += '<div class="mb-2">' + this.escapeHtml(brandResult.message) + "</div>"

      if (brandResult.property_results && brandResult.property_results.length) {
        html += "<pre>" + this.escapeHtml(this.formatPropertyResults(brandResult.property_results)) + "</pre>"
      }

      html += "</td></tr>"
    })

    html += "</tbody></table></div>"
    return html
  }

  formatPropertyResults(propertyResults) {
    return propertyResults.map((propertyResult) => {
      const objectType = this.titleizeStatus(propertyResult.object_type)
      const status = this.titleizeStatus(propertyResult.status)
      return "[" + objectType + "] " + propertyResult.property_label + ": " + status + " - " + propertyResult.message
    }).join("\n")
  }

  badgeClassForStatus(status) {
    if (status === "succeeded") return "success"
    if (status === "failed") return "danger"
    return "secondary"
  }

  titleizeStatus(status) {
    const words = String(status || "").split("_")
    return words.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
  }

  escapeHtml(value) {
    return $("<div>").text(String(value)).html()
  }
}
